module.exports = __webpack_public_path__ + "img/bg-dark-mobile.c08d5212.svg";